// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3VqEO","filesListContainer":"PosDisputesFiles_filesListContainer__2p05S","filesButton":"PosDisputesFiles_filesButton__1KS1k"};